import { getProp } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.div`
    background: #DDDDDD;
    height: 100vh;
    @media(max-width: 600px) {
        background: #EEEEEE;
    }
`;

export const Content = styled.div`
    margin-top: 20px;
`;

export const ErrorLink = styled.div`
    color: red;
    font-size: 11px;
    margin: 20px 0px;
    max-height: 70px;
`;

export const TextContainer = styled.div`
    background: #FFFFFF;
    border: solid 3px;
    border-color: ${ getProp('color') };
    border-radius: 10px;
    box-shadow: #AAAAAA 2px 2px;
    display: flex;
    flex-direction: column;
    height: 400px;
    left: calc(50% - 300px);
    overflow-y: auto;
    padding-top: 20px;
    position: relative;
    text-align: center;
    top: calc(50vh - 200px);
    width: 600px;
    @media(max-width: 600px) {
        box-shadow: none;
        left: 0px;
        position: relative;
        width: 100%;
    }
`;

export const TextError = styled.div`
    color: ${ getProp('color') };
    font-size: 30px;
    font-weight: bold;
`;

export const TextSubError = styled.div`
    color: #444444;
    font-size: 13px;
    margin-top: 20px;
`;

export const Title = styled.div`
    color: ${ getProp('color') };
    font-size: 70px;
    position: relative;
`;

export const SpanLink = styled.span`
    cursor: pointer;
`;

export const Link = styled.div`
    color: #444444;
    cursor: pointer;
    text-align: center;
    width: 100%;
`;
